import { render, staticRenderFns } from "./IconApple.vue?vue&type=template&id=5c829e45&"
import script from "./IconApple.vue?vue&type=script&lang=js&"
export * from "./IconApple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports